document.addEventListener('DOMContentLoaded', () => {
  const headerImage = document.querySelector('.header__custom-image');

  if (headerImage) {
    // Grafik nach 10 Sekunden ausblenden
    setTimeout(() => {
      headerImage.classList.add('hidden');
    }, 10000);

    // Funktion zur Kontrolle, ob die Startseite geladen wurde
    const checkIfHomepage = () => {
      if (window.location.pathname === '/') {
        headerImage.classList.remove('hidden');
      } else {
        headerImage.classList.add('hidden');
      }
    };

    // Initial prüfen, ob Startseite geladen wurde
    checkIfHomepage();

    // Bei Ajax-Navigation erneut prüfen (falls erforderlich)
    document.addEventListener('page:load', checkIfHomepage);
  }
});
